export const SORT_BY = [
  {
    label: s__('News|Newest'),
    value: 'new',
  },
  {
    label: s__('News|Oldest'),
    value: 'old',
  },
];

export const SORT_BY_FOR_API = {
  old: {
    sort_by: 'feedable_at',
    order: 'asc',
  },
  new: {
    sort_by: 'feedable_at',
    order: 'desc',
  },
};
